module.exports = __webpack_public_path__ + "img/Group 5813.37330ff8.svg";